import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var BaseFrame = function (_a) {
    var title = _a.title, appName = _a.appName, children = _a.children;
    document.title = "".concat(title, " - ").concat(appName);
    return (_jsx(_Fragment, { children: children }));
};
export default BaseFrame;
